import React from 'react';
import styled from 'styled-components';

import {
  Box, Heading, FormField, TextInput,
} from 'grommet';
import { AppAnchor } from '@Components/Control';

const StyledForm = styled(Box)`
  max-width: 100%;
  width: ${({ customWidth }) => customWidth ?? 'calc(65% * 2 / 5)'};
  min-height: 21rem;
  background-color: var(--page-alt-bg);
  box-shadow: var(--elevation);
  border-radius: var(--app-radius);

  @media (max-width: 86.875em) {
    width: ${({ customWidth }) => customWidth ?? '450px'};
  }
`;

const StyledTitle = styled(Heading)`
  letter-spacing: normal;
  line-height: 1.35;
  font-weight: 600;
  margin: 0;
`;

const StyledAnchor = styled((props) => <AppAnchor {...props} />)`
  && {
    text-align: center;
    display: block;
    font-size: 0.75rem;
    text-decoration: none;

    &:hover {
      color: ${({ hoverColor }) => hoverColor || 'var(--page-alt-highlight)'};
    }
  }
`;

const StyledField = styled(FormField)`
  margin-bottom: 1.25rem;

  > div {
    border-bottom: none;
  }
`;

const StyledFormInput = styled(TextInput)`
  background: var(--page-input-bg);
  font-size: 1rem;
  border: solid 1px var(--page-input-border);
  color: var(--page-input-text);
  padding: 0.65rem 1rem;
  border-radius: var(--app-radius);
  width: 100%;

  &:focus { border-color: var(--page-focus-highlight); }
`;

export {
  StyledForm,
  StyledTitle,
  StyledField,
  StyledAnchor,
  StyledFormInput,
};
